import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Icon, Text } from '@timelyapp/react';
import classNames from 'classnames';
import { SortableDragHandle } from 'components/Icons';
import React, { memo, useCallback } from 'react';
import styles from './SortableColumnOption.module.scss';

interface Props {
  columnId: string;
  label: string;
  isVisible: boolean;
  onColumnVisibilityChange: (columnId: string, isVisible: boolean) => void;
}

const SortableColumnOption: React.FC<Props> = memo(
  ({ columnId, label, isVisible, onColumnVisibilityChange }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isSorting } = useSortable({
      id: columnId,
    });
    const style = { transition, transform: CSS.Transform.toString(transform) };

    const handleVisibilityToggle = useCallback(() => {
      onColumnVisibilityChange(columnId, !isVisible);
    }, [columnId, isVisible, onColumnVisibilityChange]);

    return (
      <Box.Row
        key={columnId}
        ref={setNodeRef}
        alignItems="center"
        gap="large"
        className={classNames(styles.item, { [styles.isSorting]: isSorting })}
        style={style}
      >
        <Box.Row className={styles.inner} onClick={handleVisibilityToggle} gap="large" width="100%">
          <Icon
            name="Check"
            width={16}
            height={16}
            type="solid"
            className={classNames(styles.icon, { [styles.selected]: isVisible })}
          />
          <Text.Label className={styles.label} size="small" color={isVisible ? 'normal' : 'subtle'}>
            {label}
          </Text.Label>
        </Box.Row>
        <SortableDragHandle className={styles.dragHandle} {...attributes} {...listeners} />
      </Box.Row>
    );
  }
);

SortableColumnOption.displayName = 'SortableColumnOption';

export default SortableColumnOption;
